<template>
  <div>
    <div class="font-bold p-2">Table</div>

    <div v-if="!hasBookedSeatsInSelection" class="flex gap-2 px-2 text-gray-300">
      <SMButton v-tippy="'Duplicate'" icon="copy" :on-click="duplicate" />
      <SMButton v-tippy="'Delete'" icon="delete" :on-click="remove" />
    </div>

    <ul class="space-y-2 p-2">
      <li class="flex gap-1">
        <SMIcon v-tippy="'Table type'" icon="table" />
        <div class="grow flex">
          <SMButton
            class="!px-1 min-w-[3rem] grow !border-0"
            :type="isOneSideActive ? 'primary' : undefined"
            @click="setOneSideDirection"
          >
            One
          </SMButton>
          <SMButton
            class="!px-1 min-w-[3rem] grow !border-0"
            :type="isTwoSidesActive ? 'primary' : undefined"
            @click="setTwoSidesDirection"
          >
            Two
          </SMButton>
          <SMButton
            class="!px-1 min-w-[3rem] grow !border-0"
            :type="isFourSidesActive ? 'primary' : undefined"
            @click="setFourSidesDirection"
          >
            Four
          </SMButton>
        </div>
      </li>
      <li class="flex">
        <SMNumberInput
          v-model="chairsCount"
          v-tippy="'Chairs count'"
          icon="seat"
          :min="1"
          :max="20"
          :interval="1"
          class="w-full"
          @update:modelValue="onChairsCountValueChange"
        />
      </li>
      <li class="flex">
        <SMNumberInput
          v-model="width"
          v-tippy="'Width'"
          :min="20"
          :max="500"
          icon="width"
          :interval="2"
          class="w-full"
          @update:modelValue="onWidthValueChange"
        />
      </li>
      <li class="flex">
        <SMNumberInput
          v-model="height"
          v-tippy="'Height'"
          :min="20"
          :max="200"
          icon="height"
          :interval="2"
          class="w-full"
          @update:modelValue="onHeightValueChange"
        />
      </li>
    </ul>

    <ul v-if="!hasBookedSeatsInSelection && (draftEvent || pauseEvent)" class="space-y-2 px-2 py-1">
      <li>
        <SMInput v-model="meta1" v-tippy="'Meta 1'" icon="1" placeholder="Meta 1" @change="onChangeMeta1" />
      </li>

      <li>
        <SMInput v-model="meta2" v-tippy="'Meta 2'" icon="2" placeholder="Meta 2" @change="onChangeMeta2" />
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
/* eslint-disable */
import SMButton from '@/components/ui/SMButton.vue';
import SMIcon from '@/components/ui/SMIcon.vue';
import SMInput from '@/components/ui/SMInput.vue';
import SMNumberInput from '@/components/ui/SMNumberInput.vue';
import SMSlider from '@/components/ui/SMSlider.vue';
import { EVENTSTATUS, SEATSTATUS, TABLE, TYPE } from '@/constants';
import filter from 'lodash/filter';
import uniq from 'lodash/uniq';
import eventbus from 'tiny-emitter/instance';

export default {
  props: ['unit'],
  components: {
    SMIcon,
    SMSlider,
    SMInput,
    SMButton,
    SMNumberInput
},
  data() {
    return {
      isGrouped: false,
      autoWidth: false,
      dragStarted: false,
      chairsCount: TABLE.RECTANGULAR.SEATSCOUNT,
      chairs: {
        tooltip: 'hover',
        width: 200,
        min: 1,
        max: 20,
        interval: 1,
      },
      width: TABLE.RECTANGULAR.WIDTH,
      widthSettings: {
        tooltip: 'hover',
        width: 200,
        min: 20,
        max: 500,
        interval: 2,
      },
      height: TABLE.RECTANGULAR.HEIGHT,
      heightSettings: {
        tooltip: 'hover',
        width: 200,
        min: 20,
        max: 200,
        interval: 2,
      },
      blockedSeatsCount: '',
      chairsMin: 0,
      seatsDirection: TABLE.RECTANGULAR.DIRECTION.TWOSIDES,
    };
  },
  created() {
    const { width, height, autoWidth, isGrouped } = this.unit.attributes;
    this.chairsCount = this.unit.seats.length;
    this.height = height;
    this.width = width;
    this.autoWidth = autoWidth;
    this.isGrouped = isGrouped;
    if (this.unit) {
      // check if the unit has blocked or cart seats
      this.blockedSeatsCount = filter(this.unit.seats, (s) => s.locked).length;
      this.occupiedSeatsCount = filter(
        this.unit.seats,
        (s) => s.attributes.status === SEATSTATUS.OCCUPIED || s.attributes.status === SEATSTATUS.RESERVED
      ).length;
      this.cartSeatsCount = filter(this.unit.seats, (s) => s.attributes.status === SEATSTATUS.CART).length;
      this.chairsMin = this.blockedSeatsCount + this.cartSeatsCount + this.occupiedSeatsCount;
      this.seatsDirection = this.unit.seatsDirection;
    }
  },
  computed: {
    draftEvent() {
      return this.$app.props.status === EVENTSTATUS.DRAFT;
    },
    pauseEvent() {
      return this.$app.props.status === EVENTSTATUS.PAUSED;
    },
    meta1() {
      return this.unit.attributes.meta1;
    },
    meta2() {
      return this.unit.attributes.meta2;
    },
    isOneSideActive() {
      return this.seatsDirection === TABLE.RECTANGULAR.DIRECTION.ONESIDE;
    },
    isTwoSidesActive() {
      return this.seatsDirection === TABLE.RECTANGULAR.DIRECTION.TWOSIDES;
    },
    isFourSidesActive() {
      return this.seatsDirection === TABLE.RECTANGULAR.DIRECTION.FOURSIDES;
    },
    checkIfMultipleCategory() {
      let assignedCats = [];
      this.unit.seats.forEach((s) => {
        if (s.attributes.categoryId) {
          const categoryId = s.attributes.categoryId.toString().trim();
          assignedCats.push(categoryId);
        }
      });
      assignedCats = uniq(assignedCats);
      return assignedCats.length > 1;
    },
    hasBookedSeatsInSelection() {
      let bookedUnits = 0;
      if (this.unit.seats.length > 0) {
        this.unit.seats.forEach((u) => {
          if (u.type === TYPE.TABLESEAT) {
            bookedUnits +=
              u.attributes.status === SEATSTATUS.OCCUPIED ||
              u.attributes.status === SEATSTATUS.RESERVED ||
              u.attributes.status === SEATSTATUS.CART
                ? 1
                : 0;
          } else if (u.type === TYPE.TABLE) {
            const bookedTableSeats = u.seats.filter(
              (s) =>
                s.attributes.status === SEATSTATUS.OCCUPIED ||
                s.attributes.status === SEATSTATUS.RESERVED ||
                s.attributes.status === SEATSTATUS.CART
            );
            bookedUnits += bookedTableSeats.length > 0 ? 1 : 0;
          }
        });
      }
      return !!bookedUnits;
    },
  },
  watch: {
    chairsCount(newVal, oldVal) {
      this.unit.seats.forEach((s) => {
        // redraw lockshape for locked seats
        if (s.locked) {
          s.removeLockClass();
          s.removeLockShape();
          s.addLockClass();
          s.initLockShape();
          s.initReservedShape();
          s.initCartShape();
        }
      });
    },
  },
  methods: {
    onChangeMeta1(value) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      this.unit.changeMeta1(value.trim());
    },
    onChangeMeta2(value) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      this.unit.changeMeta2(value.trim());
    },

    onDragStart() {
      this.unit.seats.forEach((s) => {
        if (s.locked) {
          s.removeLockClass();
          s.removeLockShape();
        }
        if (s.disabled) {
          s.removeDisabledClass();
          s.removeDisabledShape();
        }
      });
      this.dragStarted = true;
    },
    onDragEnd() {
      this.unit.seats.forEach((s) => {
        if (s.locked) {
          s.addLockClass();
          s.initLockShape();
        }
        if (s.disabled) {
          s.addDisabledClass();
          s.initDisabledShape();
        }
      });
      this.dragStarted = false;
    },
    setAutoWidth(value) {
      this.unit.changeAutoWidth(value);
      this.onDragEnd();
    },
    resetGroupSeating() {
      this.unit.seats.forEach((item) => {
        item.enable();
        item.removeFromPreviousGroup();
      });
    },
    setOneSideDirection() {
      this.resetGroupSeating();
      this.onDirectionValueChange(TABLE.RECTANGULAR.DIRECTION.ONESIDE);
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
    },
    setTwoSidesDirection() {
      this.resetGroupSeating();
      this.onDirectionValueChange(TABLE.RECTANGULAR.DIRECTION.TWOSIDES);
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
    },
    setFourSidesDirection() {
      this.resetGroupSeating();
      this.onDirectionValueChange(TABLE.RECTANGULAR.DIRECTION.FOURSIDES);
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
    },
    onChairsCountValueChange(value) {
      this.resetGroupSeating();
      this.unit.changeSeatsCount(value);

      eventbus.emit('selection:delayedHistory', 'Table chair count change');
      eventbus.emit('seatmap:updated', this.$app.seatmap.seats, this.$app.seatmap.units, this.$app.seatmap.sections);
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
    },
    onHeightValueChange(value) {
      this.unit.changeHeight(value);
      eventbus.emit('selection:delayedHistory', 'Table height changed');
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
    },
    onWidthValueChange(value) {
      this.unit.changeWidth(value);
      eventbus.emit('selection:delayedHistory', 'Table width changed');
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
    },
    onDirectionValueChange(value) {
      this.unit.seatsDirection = value;
      this.onDragEnd();
      eventbus.emit('selection:delayedHistory', 'Table type change');
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
      this.seatsDirection = value
    },
    isActiveClass(direction) {
      return direction === this.unit.seatsDirection;
    },
    onInputClick() {
      // intentionally left blank
    },
    duplicate() {
      eventbus.emit('selection:clone');
    },
    remove() {
      eventbus.emit('selection:remove');
    },
    onCheckboxToggle(val) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      this.unit.attributes.isGrouped = val;
      this.resetGroupSeating();
    },
  },
};
</script>
<style lang="scss"></style>
